import React from 'react';

import DebugModeProvider from '../../../components/DebugMode/DebugModeProvider';
import DebugOverlays from '../../../components/DebugMode/DebugOverlays';
import MetricCacheProvider from '../../MetricCacheProvider';

import CompoundMetricsProvider from './CompoundMetricsProvider';
import ExcludedPaceDatesProvider from './ExcludedPaceDatesProvider';
import MetricListsProvider from './MetricListsProvider';
import MetricOptionsProvider from './MetricOptionsProvider';
import MetricsProvider from './MetricsProvider';
import SpecialMetricsProvider from './SpecialMetricsProvider';

const MetricAndChartDefinitionsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  return (
    <MetricCacheProvider>
      <DebugModeProvider>
        <DebugOverlays />
        <MetricsProvider>
          <CompoundMetricsProvider>
            <SpecialMetricsProvider>
              <MetricOptionsProvider>
                <ExcludedPaceDatesProvider>
                  <MetricListsProvider>{children}</MetricListsProvider>
                </ExcludedPaceDatesProvider>
              </MetricOptionsProvider>
            </SpecialMetricsProvider>
          </CompoundMetricsProvider>
        </MetricsProvider>
      </DebugModeProvider>
    </MetricCacheProvider>
  );
};

export default MetricAndChartDefinitionsProvider;
